import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { UseBannerStateReturn } from './hook';

export const {
	Context: PetitionEditBannerStateContext,
	Provider: PetitionEditBannerStateContextProvider,
	useContext: usePetitionEditBannerState,
} = createMandatoryContext<UseBannerStateReturn | undefined, UseBannerStateReturn>(undefined, {
	name: 'BannerStateContext',
	processProviderProps: ({ data, actions }) => ({ data, actions }),
});

export type PetitionEditPageBannerState = ReturnType<typeof usePetitionEditBannerState>;
